'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../aviary-core/dist/cjs/index.cjs');

/**
 * SVG Illustration of patient plan web
 */ const PatientPlanWeb = ({ assetColor = index.ASSET_COLORS.grey, size = index.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "51.7979",
                cy: "51.7979",
                r: "51.7979",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "19.8789",
                y: "31.498",
                width: "63.6974",
                height: "37.0985",
                rx: "3.49986",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                opacity: "0.7",
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.8789 61.8787V65.0991C19.8789 67.032 21.4458 68.5989 23.3788 68.5989H80.0764C82.0093 68.5989 83.5763 67.032 83.5763 65.0991V61.8787H19.8789Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "42",
                y: "68.5957",
                width: "19.5992",
                height: "6.01975",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "35.1406",
                y: "74.4766",
                width: "33.1786",
                height: "1.67993",
                rx: "0.839965",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "45",
                y: "42",
                width: "32",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "30",
                y: "52",
                width: "47",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "30",
                y: "57",
                width: "47",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "45",
                y: "37",
                width: "32",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "45",
                y: "47",
                width: "32",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M30.3378 45.9975C30.1172 46.6438 30 47.3268 30 48.0171V49.1844H41.4997V48.0024C41.4997 47.3268 41.3898 46.6512 41.1618 46.0121V45.9975C40.6849 44.6682 39.6787 43.6401 38.4373 43.0898C37.6738 43.6254 36.7409 43.9339 35.7503 43.9339C34.7597 43.9339 33.8259 43.6254 33.0624 43.0972C31.8145 43.641 30.8157 44.6755 30.3378 45.9975Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M35.7489 42.349C37.4994 42.349 38.9276 40.9282 38.9276 39.1704C38.9276 37.4126 37.4994 36 35.7489 36C33.9985 36 32.5703 37.4209 32.5703 39.1704C32.5703 40.9199 33.9994 42.349 35.7489 42.349Z",
                fill: theme.ds5.asset[assetColor]["500"]
            })
        ]
    });
};

exports.PatientPlanWeb = PatientPlanWeb;
//# sourceMappingURL=PatientPlanWeb.cjs.map
